export const getSortIconName = (
  activeOrder: 'asc' | 'desc' | undefined
): 'sort-asc' | 'sort-desc' | 'sortable' => {
  if (activeOrder === 'asc') return 'sort-asc';
  if (activeOrder === 'desc') return 'sort-desc';
  return 'sortable';
};
